import type { ShipmentSpotBidAddressResponse } from './api';

export const normalizeShipmentSpotBidAddress = (list: ShipmentSpotBidAddressResponse) => {
  if (!list) {
    return [];
  }

  const groupedData = Object.groupBy(list, (item) => item.distributionName);
  const newData = [];
  for (const key in groupedData) {
    newData.push({ distributionName: key, providers: groupedData[key] });
  }
  return newData;
};
